import { render, staticRenderFns } from "./ListRefundView.vue?vue&type=template&id=23be215e&"
import script from "./ListRefundView.vue?vue&type=script&lang=js&"
export * from "./ListRefundView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports